import { GoogleSheetsSyncPage, SyncType } from '../../components/GoogleSheetsSyncPage/GoogleSheetsSyncPage';
import { PageId } from '../../components/Sidebar/Sidebar';
import defaultSheets from '../../config/default_sheets';

const ProductGroupSyncPage = () => {
  return (
    <GoogleSheetsSyncPage
      title="Sync Product Group Data from Google Sheets"
      syncType={SyncType.ProductGroup}
      pageId={PageId.ProductGroup}
      defaultSheetUrl={defaultSheets.ProductGroup.defaultSheetUrl}
      defaultRange={defaultSheets.ProductGroup.defaultRange}
    />
  );
};

export default ProductGroupSyncPage;
